import React from "react";
import "./Partner.css";
const Partner = () => {
  const data = [
    {
      id: 1,
      img: require("../../Assets/img3.png"),
      title: "Tech-Enabled Systems",
      description:
        "Manage your schedule, appointments, and payments on a single platform.",
    },
    {
      id: 2,
      img: require("../../Assets/img4.png"),
      title: "Work on Your Terms",
      description: "Choose your availability and take control of your career.",
    },
    {
      id: 3,
      img: require("../../Assets/img5.png"),
      title: "Competitive Earnings",
      description: "Get paid fairly for your expertise.",
    },
    {
      id: 4,
      img: require("../../Assets/img6.png"),
      title: "Safe & Secure",
      description:
        "Verified clients, secure transactions, and reliable processes.",
    },

    {
      id: 5,
      img: require("../../Assets/img7.png"),
      title: "Convenience",
      description:
        "Simple onboarding and easy-to-use tools for daily practice.",
    },
  ];
  return (
    <>
      <div className="partner-section">
        <h1 className="heading-h1">Why Partner with Wihan?</h1>
        <div className="partner-card">
          {data?.map((item) => {
            return (
              <div className="card-content" key={item.id}>
                <div className="partner-card-img">
                  <img src={item?.img} alt="" className="partner-img" />
                </div>
                <h5 className="patner-card-title">{item?.title}</h5>
                <p className="partner-card-text">{item?.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Partner;
